import { gql, useQuery } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import { TicketFeature } from 'apollo/types';

const LIST_TICKET_FEATURES = gql`
  query listTicketFeaturesBackOffice {
    listTicketFeaturesBackOffice {
      id
      slug
      name {
        ...LocalizedTextFields
      }
      status
      thingToDoId
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const useListTicketFeaturesQuery = () => {
  return useQuery<{ listTicketFeaturesBackOffice: TicketFeature[] }>(
    LIST_TICKET_FEATURES,
    {}
  );
};

export default useListTicketFeaturesQuery;
